import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicerProvider } from './servicer';
import { SystemDashboardUsersApiRequest } from './models/system-dashboard-users-api-request';
import { SystemDashboardUsersApiResponse } from './models/system-dashboard-users-api-response';
import { User } from './models/user';
import { GenericItem } from './models/generic-item';

/**
 * [システム][ダッシュボード]ユーザー一覧 APIの通信用プロバイダー.
 */
@Injectable()
export class SystemDashboardUsersServiceProvider {

  /** APIのパス */
  private readonly PATH = '/v3/system/dashboardUsers';

  constructor(public servicer: ServicerProvider) { }

  /**
   * ユーザー一覧を取得する.
   * 
   * @param userIds ユーザーIDの一覧
   * @returns ユーザー一覧, 画像URLプレフィックス
   */
  public get(userIds: number[]): Observable<[User[], string]> {
    const requestBody: SystemDashboardUsersApiRequest = { userIds: userIds };
    return this.servicer.postApi<SystemDashboardUsersApiRequest, GenericItem<SystemDashboardUsersApiResponse>>
      (this.PATH, requestBody).map((responseBody) => this.toModel(responseBody));
  }

  /**
   * レスポンスボディをモデルに変換する.
   * 
   * @param responseBody レスポンスボディ
   * @returns ユーザー一覧, 画像URLプレフィックス
   */
  private toModel(responseBody: GenericItem<SystemDashboardUsersApiResponse>): [User[], string] {
    return [
      responseBody.item.users,
      responseBody.item.imgUrlPrefix
    ];
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-dashboard-users-service.ts